import PropTypes from 'prop-types';

import Tag from 'shopper/components/Tag/V1';

import Tooltip from './Tooltip';

const OfferTag = ({ children, isFirst = false }) => (
  <Tooltip isFirst={isFirst} tagName={children}>
    <Tag filled>{children}</Tag>
  </Tooltip>
);

OfferTag.propTypes = {
  children: PropTypes.string.isRequired,
  isFirst: PropTypes.bool,
};

export default OfferTag;
